/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementYouTubeIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementYouTubeIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.6"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 4H5C3.34315 4 2 5.34315 2 7V9C2 10.6569 3.34315 12 5 12H11C12.6569 12 14 10.6569 14 9V7C14 5.34315 12.6569 4 11 4ZM5 3C2.79086 3 1 4.79086 1 7V9C1 11.2091 2.79086 13 5 13H11C13.2091 13 15 11.2091 15 9V7C15 4.79086 13.2091 3 11 3H5Z"
            fill="currentColor"
          />
          <path d="M6 11V5.16406L11 8L6 11Z" fill="currentColor" />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementYouTubeIcon.tags = [
  'youtube',
  'yt',
  'tube',
  'you',
  'player',
  'video',
  'videos',
  'play',
  'media',
  'streaming',
  'watch',
  'entertainment',
];

ElementYouTubeIcon.category = 'Navigator';

ElementYouTubeIcon.iconSize = 16;
